var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnectWithFriends(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 942,
    viewBox: "0 0 1440 942",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 942,
    transform: "translate(1440 942) rotate(180)",
    fill: "url(#paint0_radial_87_309)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 591,
    y: 95,
    width: 53.08,
    height: 8.42,
    transform: "rotate(74 591 95)",
    fill: "#9DED1A",
    fillOpacity: 0.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 669,
    width: 41.08,
    height: 11.42,
    transform: "rotate(-45 11 669)",
    fill: "#480CA7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1243,
    y: 224,
    width: 42.08,
    height: 9.42,
    transform: "rotate(-142 1243 224)",
    fill: "#FF21FB",
    fillOpacity: 0.35
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 628,
    y: 644,
    width: 54.08,
    height: 11.42,
    transform: "rotate(63 628 644)",
    fill: "#DCBCFA",
    fillOpacity: 0.45
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 956,
    y: 683,
    width: 46.08,
    height: 12.42,
    transform: "rotate(-136 956 683)",
    fill: "#480CA7",
    fillOpacity: 0.6
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 517,
    width: 20.08,
    height: 7.42,
    transform: "rotate(-29 14 517)",
    fill: "#9DED1A",
    fillOpacity: 0.85
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 517,
    y: 488,
    width: 41.08,
    height: 15.42,
    transform: "rotate(-21 517 488)",
    fill: "#FF21FB",
    fillOpacity: 0.6
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 631.343,
    y: 330.588,
    width: 41.1879,
    height: 11.7288,
    transform: "rotate(-41 631.343 330.588)",
    fill: "#03A3F5",
    fillOpacity: 0.65
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1390.4,
    cy: 678.4,
    r: 6.6,
    transform: "rotate(180 1390.4 678.4)",
    fill: "#F62584",
    fillOpacity: 0.35
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 485.4,
    cy: 112.4,
    r: 7.6,
    transform: "rotate(180 485.4 112.4)",
    fill: "#480CA7",
    fillOpacity: 0.75
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1316.9,
    cy: 658.9,
    r: 5.1,
    transform: "rotate(180 1316.9 658.9)",
    fill: "#755FFE",
    fillOpacity: 0.45
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 876.4,
    cy: 81.9938,
    r: 8.6,
    transform: "rotate(180 876.4 81.9938)",
    fill: "#755FFE"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1126.4,
    cy: 338.4,
    r: 6.6,
    transform: "rotate(180 1126.4 338.4)",
    fill: "#9DED1A",
    fillOpacity: 0.75
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 230.4,
    cy: 452.4,
    r: 4.6,
    transform: "rotate(180 230.4 452.4)",
    fill: "#4BC8EF",
    fillOpacity: 0.45
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 985.9,
    cy: 431.9,
    r: 10.1,
    transform: "rotate(180 985.9 431.9)",
    fill: "#480CA7",
    fillOpacity: 0.35
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 969.9,
    cy: 431.9,
    r: 9.1,
    transform: "rotate(180 969.9 431.9)",
    fill: "#F54721",
    fillOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M709.38 622.985L718.501 614.479L721.306 626.631L709.38 622.985Z",
    fill: "#FFED36",
    fillOpacity: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M390.628 299.414L397.832 290.194L409.418 291.822L413.801 302.671L406.597 311.89L395.011 310.262L390.628 299.414Z",
    fill: "#480CA7",
    fillOpacity: 0.45
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M936.934 70.2591L928.318 69.0483L925.059 60.9818L930.415 54.1261L939.031 55.3369L942.29 63.4034L936.934 70.2591Z",
    fill: "#03A3F5",
    fillOpacity: 0.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M829.016 364.534L817.497 348.084L833.947 336.566L845.466 353.016L829.016 364.534Z",
    fill: "#FC9E1C",
    fillOpacity: 0.35
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M936.344 476.289L921.398 473.922L923.765 458.976L938.711 461.344L936.344 476.289Z",
    fill: "#DCBCFA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M624.979 665.557L619.054 684.936L605.234 670.115L624.979 665.557Z",
    fill: "#03A3F5",
    fillOpacity: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M277.462 32.1044L261.777 26.0835L274.833 15.5104L277.462 32.1044Z",
    fill: "#FC9E1C",
    fillOpacity: 0.65
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1184.76 747.698L1164.01 759.202L1164.42 735.477L1184.76 747.698Z",
    fill: "#9DED1A",
    fillOpacity: 0.6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M194.834 74.398L201.692 68.2238L197.939 59.7945L205.929 64.408L212.786 58.2339L210.868 67.2593L218.859 71.8729L209.682 72.8374L207.764 81.8628L204.011 73.4335L194.834 74.398Z",
    fill: "#FF21FB",
    fillOpacity: 0.35
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M463.305 432.696L461.563 426.62L455.246 426.4L460.486 422.865L458.744 416.789L463.725 420.681L468.965 417.146L466.803 423.086L471.784 426.977L465.467 426.757L463.305 432.696Z",
    fill: "#F62584",
    fillOpacity: 0.6
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M364.995 512.699L359.657 516.721L361.833 523.041L356.358 519.208L351.02 523.23L352.974 516.838L347.498 513.004L354.182 512.888L356.136 506.495L358.312 512.815L364.995 512.699Z",
    fill: "#F62584",
    fillOpacity: 0.45
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1307.15 47.8495L1311.54 57.137L1321.45 59.8489L1312.16 64.2402L1309.45 74.1491L1305.06 64.8617L1295.15 62.1498L1304.44 57.7584L1307.15 47.8495Z",
    fill: "#9DED1A",
    fillOpacity: 0.45
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M281.502 245.065L283.269 236.529L277.939 229.632L286.475 231.398L293.372 226.069L291.605 234.604L296.935 241.502L288.399 239.735L281.502 245.065Z",
    fill: "#F54721",
    fillOpacity: 0.35
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M555.414 391.372L553.938 383L545.52 381.817L553.025 377.826L551.549 369.455L557.664 375.36L565.17 371.369L561.443 379.01L567.558 384.914L559.14 383.731L555.414 391.372Z",
    fill: "#4BC8EF",
    fillOpacity: 0.85
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1286.52 151.878L1295.94 147.682L1294.86 137.421L1301.77 145.088L1311.19 140.892L1306.03 149.827L1312.94 157.493L1302.84 155.348L1297.69 164.283L1296.61 154.023L1286.52 151.878Z",
    fill: "#9DED1A",
    fillOpacity: 0.75
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1031.74 468.253L1030.08 475.474L1036.43 479.291L1029.05 479.937L1027.38 487.158L1024.48 480.336L1017.1 480.982L1022.69 476.12L1019.8 469.298L1026.15 473.115L1031.74 468.253Z",
    fill: "#FC9E1C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_87_309",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(720 471) rotate(92.073) scale(650.195 2159.16)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#B30071",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#6B0C48"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectWithFriends);
export default __webpack_public_path__ + "static/media/connect_with_friends.a4aa6b60acd7bb096aeb272a0db388c3.svg";
export { ForwardRef as ReactComponent };